<template>
  <div class="content_page">
    <div class="top">
      <div class="title">
        <img class="xiushi" :src="xiushiImg" alt />
        <span class="text">{{contentName}}</span>
      </div>
      <backBtn></backBtn>
    </div>
    <leftBack @getPreContent="oldActiveChapterArray('pre')" v-show="!hideArrowbtn"></leftBack>
    <rightBack @getNextContent="oldActiveChapterArray('next')" v-show="!hideArrowbtn"></rightBack>
    <div class="content_body">
      <div class="content_box">
        <div class="inner_box">
          <div class="innerdiv">
            <ul
              class="content_tab"
              :class="{sigleContentWidth:isSingleContentStructure}"
              v-show="content_tabs.length>1"
            >
              <li
                v-for="(item,index) in content_tabs"
                :key="index"
                :class="{active_css: item.isActive}"
                @click="click_tab(index)"
              >{{item.title}}</li>
            </ul>
            <div
              class="content_left"
              ref="content_left"
              :class="{sigleContentStyle:(isSingleContentStructure &&
                  !isSlide &&!isVideo),sigleSlideStyle:(isSingleContentStructure&&(isSlide||isVideo))}"
            >
              <!-- 视频 -->
              <videoplayer :videosrc="videoPath" v-if="isVideo" ref="myVideoPlayer" style="width:100%;height:88%;"></videoplayer>
              <!-- 非轮播  单图片 -->
              <left-img :imgurl="leftImgUrl" v-if="isSingleImg"></left-img>
              <!-- 单内容结构的内容 -->
              <div
                class="Content"
                v-if="!isSlide && isSingleContentStructure && !cjwt && !isVideo && !isSingleImg"
                v-html="currentContent"
              ></div>
              <!-- 常见问题 -->
              <div
                class="Content cjwt"
                v-if="!isSlide &&!isVideo && isSingleContentStructure && cjwt && !isSingleImg"
              >
                <div v-for="(item,index) in currentContent" :key="index" style="margin-bottom:10px;">

                    <p style="font-family:sans-serif;font-size:16px;cursor: pointer;" @click="clickQuestion(index)">
                      <strong>
                        <span
                          style="font-size:16px;font-family:微软雅黑, Microsoft YaHei;color:#FF9900;line-height:2;"
                        >（{{index+1}}）{{item.question}}</span>
                      </strong>
                      <i style="color:#FF9900;" :class="{'iconfont icon-fanhui1 down':!item.active,'iconfont icon-fanhui1 up':item.active}"></i> 
                    </p>
                    <p style="font-family:sans-serif;font-size:16px;" v-show="item.active">
                      <span style="font-size:16px;font-family:微软雅黑, Microsoft YaHei;line-height:2;">
                        &nbsp; &nbsp; &nbsp; &nbsp;
                        {{item.answer}}
                      </span>
                    </p>
                
                </div>
              </div>
              <!-- 图片组 -->
              <slider-show :slides="slides" :inv="invTime" v-show="isSlide"></slider-show>
              <!-- 图片查看 -->
              <viewer :images="img" @inited="inited" class="viewer" ref="viewer">
                <template slot-scope="scope">
                  <img v-for="src in scope.images" :src="src" :key="src" v-show="false" />
                  {{scope.options}}
                </template>
              </viewer>
            </div>
            <!-- 内容右边部分 -->
            <content-right v-if="!isSingleContentStructure" :current-content="currentContent"></content-right>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";
import contentRight from "../components/ContentRight";
import backBtn from "../components/BackBtn";
import leftBack from "../components/LeftBack";
import rightBack from "../components/RightBack";
import videoplayer from "../components/VideoPlayer";
import sliderShow from "../components/sliderShow";
import leftImg from "../components/leftImg";
import $ from "jquery";
export default {
  name: "contents",
  components: {
    contentRight,
    backBtn,
    leftBack,
    rightBack,
    videoplayer,
    sliderShow,
    Viewer,
    leftImg
  },
  data() {
    return {
      contentName: "",
      content_tabs: [],
      preContent: "",
      currentContent: "",
      nextContent: "",
      picturegroups: [],
      leftImgUrl: "",
      isSingleImg: false,
      isVideo: false,
      hideArrowbtn: false,
      cjwt: false,
      //是否是单结构
      isSingleContentStructure: false,
      //是否需要轮播
      isSlide: false,
      invTime: 2000,
      slides: [
        {
          src: "",
          title: ""
        }
      ],
      videoPath: "",
      currentChapterId: "",
      errMsg: "",
      topHeight: "auto",
      pictureGroupStyle: {
        width: "100%"
      },
      img: [],
      xiushiImg:''
      // toNextIsFromHead:false,//下一节是从头开始的
      // toPreIsFromEnd:false//上一节是从尾部开始的
    };
  },
  created() {
    this.xiushiImg="/images/neirongzhuangshi3.png?v="+this.$version;
    window.imageView = this.show;
    this.currentChapterId = this.$route.query.id;
    //获取存储的章节对象，刷新的情况下页面不变
    let currentChapterObj = JSON.parse(
      window.sessionStorage.getItem("currentChapterObj")
    );
    if (currentChapterObj && currentChapterObj.id) {
      this.currentChapterId = currentChapterObj.id;
    }
    let chapterId = this.currentChapterId;
    if (chapterId == "gzjy") {
      this.contentName = "馆长寄语";
      this.hideArrowbtn = true; //不显示左右按钮
      this.isSingleContentStructure = true;
      this.isSlide = false;
      this.cjwt = false;
      this.getGzjyData();
    } else if (chapterId == "zxgy") {
      this.contentName = "咨询馆员";
      this.hideArrowbtn = true;
      this.isSingleContentStructure = true;
      this.isSlide = false;
      this.cjwt = false;
      this.getZxgyData();
    } else if (chapterId == "cjwt") {
      this.contentName = "常见问题";
      this.hideArrowbtn = true;
      this.isSingleContentStructure = true;
      this.isSlide = false;
      this.cjwt = true;
      this.getCjwtData();
    } else if (chapterId == "tips") {
      this.contentName = "Tips";
      this.hideArrowbtn = true;
      this.isSingleContentStructure = true;
      this.isSlide = false;
      this.getTipsData();
    } else {
      this.hideArrowbtn = false; //显示左右按钮
      let chapterListIds = JSON.parse(
        window.sessionStorage.getItem("chapterListIds")
      );
      for (let i = 0; i < chapterListIds.length; i++) {
        if (chapterListIds[i].id == chapterId) {
          this.contentName = chapterListIds[i].name;
          break;
        }
      }
      this.oldActiveChapterArrayData(chapterId);
    }
    console.log('contentName',this.contentName);
    // this.setGlobleTitle(this.contentName + " - " + this.globleTitle);
  },
  mounted() {
   
    this.$watch("currentContent", function() {
      // 内容右边显示 获取右边的内容中的图片
      if (!this.isSingleContentStructure) {
        let allImages = [];
        $(".content_right img").each(function(i, v) {
          allImages.push($(v).attr("src"));
        });
        allImages = [...new Set(allImages)];
        this.img = allImages;
      }
      //单内容结构中的的图片
      if (
        !this.isSlide &&
        this.isSingleContentStructure &&
        !this.cjwt &&
        !this.isVideo &&
        !this.isSingleImg
      ) {
        let allImages = [];
        $(".Content img").each(function(i, v) {
          allImages.push($(v).attr("src"));
        });
        allImages = [...new Set(allImages)];
        this.img = allImages;
      }
    });
  },
  beforeUpdate() {
    if (this.content_tabs.length > 1) {
      this.topHeight = "75px";
    } else {
      this.topHeight = "auto";
    }
    if (this.isSingleContentStructure && this.isSlide) {
      //单图片组
      this.pictureGroupStyle.width = "55%";
    }
  },
  methods: {
     clickQuestion(index){
      this.currentContent[index].active = !this.currentContent[index].active;
    },
    //图片预览
    inited(viewer) {
      this.$viewer = viewer;
    },
    show(idx) {
      this.$viewer.view(idx);
    },
    error() {
      this.errMsg = "";
    },
    //咨询馆员
    getZxgyData() {
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/ConsultationMsg")
        .then(
          res => {
            let data = JSON.parse(res.body.consultation);
            if (data) {
              this.currentContent = data;
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    },
    //常见问题
    getCjwtData() {
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/ComProblem")
        .then(
          res => {
            let data = JSON.parse(res.body.comproblem);
            if (data) {
              console.log("常见问题",data);
              if(data.length){
                data.map(item=>{
                  item.active = false;
                })
              }
              this.currentContent = data;
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    },
    //TIps
    getTipsData() {
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/conTips")
        .then(
          res => {
            let data = JSON.parse(res.body.tips);
            if (data) {
              this.currentContent = data.content;
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    },
    //获取馆长寄语
    getGzjyData() {
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/CuratorMsg")
        .then(
          res => {
            let data = JSON.parse(res.body.curatorMessage);
            if (data) {
              this.currentContent = data;
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    },
    //获取相邻章节内容
    oldActiveChapterArray(flag) {
      let isPc = false; //是否是电脑端
      if (document.body.clientWidth > 768) {
        isPc = true;
      }
      if (this.isVideo) {
        this.$refs.myVideoPlayer.player.pause();
      }
    
      //获取存储的章节数组
      let oldActiveChapterArray = JSON.parse(
        window.sessionStorage.getItem("activeChaperArraySort")
      );
      

      let currentChapterId = this.currentChapterId;
      //获取存储的ids 与当前chapterId做匹配，确定接下来的id
      let chapterListIds = JSON.parse(
        window.sessionStorage.getItem("chapterListIds")
      );
      //取出来最原始的的chapterData
      let initchapterData = JSON.parse(
        window.sessionStorage.getItem("initchapterData")
      );
      for (var i = 0; i < chapterListIds.length; i++) {
        if (currentChapterId == chapterListIds[i].id) {
          let chapterObj = {
            id: "",
            name: ""
          };
         
          // 对章节数组的顺序与内容中左右操作进行顺序匹配
          let firstItem;
          let lastItem;
          if(oldActiveChapterArray&&oldActiveChapterArray.length){
            firstItem = oldActiveChapterArray[0];
           lastItem =
            oldActiveChapterArray[oldActiveChapterArray.length - 1];
          }
         
          if (flag == "pre") {
            // 左移动
            if (currentChapterId == initchapterData[0].id) {
              // 到第一节什么都不做
              this.$layer.msg("到第一节啦！");
              return;
            } else {
              if (isPc) {
                //pre中不属于oldActiveChapterArray后4项及initchapterData原始数组第一项就移动
                if (oldActiveChapterArray.length > 5) {
                  let belonglast4Ids = false;
                  for (
                    let u = initchapterData.length - 4;
                    u < initchapterData.length;
                    u++
                  ) {
                    if (currentChapterId == initchapterData[u].id) {
                      belonglast4Ids = true;
                      break;
                    }
                  }

                  if (!belonglast4Ids) {
                    oldActiveChapterArray.splice(
                      oldActiveChapterArray.length - 1,
                      1
                    );
                    oldActiveChapterArray.unshift(lastItem);
                  }
                }
              }
              //若当前id在chapterListIds中第一位，则展示最后一个id内容
              if (i == 0) {
                chapterObj = chapterListIds[chapterListIds.length - 1];
                this.contentName =
                  chapterListIds[chapterListIds.length - 1].name;
              } else {
                chapterObj = chapterListIds[i - 1];
                this.contentName = chapterListIds[i - 1].name;
              }
            }
          } else {
            // next
            if (
              currentChapterId == initchapterData[initchapterData.length - 1].id
            ) {
              // 到最后一节什么都不做
              this.$layer.msg("到最后一节啦！");
              return;
            } else {
              if (isPc) {
                //next 没有到最后一节
                if (oldActiveChapterArray.length > 5) {
                  let belongTop4Ids = false;
                  for (let u = 0; u < 4; u++) {
                    if (currentChapterId == oldActiveChapterArray[u].id) {
                      belongTop4Ids = true;

                      break;
                    }
                  }
                  //不属于oldActiveChapterArray前4项及initchapterData原始数组最后一项就移动 进入到这里的都不是最后一项
                  if (!belongTop4Ids) {
                    oldActiveChapterArray.splice(0, 1);
                    oldActiveChapterArray.push(firstItem);
                  }
                }
              }
              //若当前id在chapterListIds中最后一位，则展示第一个id内容
              if (i == chapterListIds.length - 1) {
                chapterObj = chapterListIds[0];
                this.contentName = chapterListIds[0].name;
              } else {
                chapterObj = chapterListIds[i + 1];
                this.contentName = chapterListIds[i + 1].name;
              }
            }
          }
          if (isPc) {
            //改变选中状态
            for (let m = 0; m < oldActiveChapterArray.length; m++) {
              if (chapterObj.id == oldActiveChapterArray[m].id) {
                oldActiveChapterArray[m].isActive = true;
                oldActiveChapterArray[m].isHover = true;
              } else {
                oldActiveChapterArray[m].isActive = false;
                oldActiveChapterArray[m].isHover = false;
              }
            }
            //存储当前章节数组的顺序，便于返回时还停留在当前章节 或者 当前章节的选中状态
            window.sessionStorage.setItem(
              "activeChaperArraySort",
              JSON.stringify(oldActiveChapterArray)
            );
          }
          this.setGlobleTitle(this.contentName + " - " + this.globleTitle);
          this.currentChapterId = chapterObj.id;
          //请求数据
          this.oldActiveChapterArrayData(chapterObj.id);
          //存储当前章节id，刷新是保持当前页内容
          window.sessionStorage.setItem(
            "currentChapterObj",
            JSON.stringify(chapterObj)
          );
          this.$router.replace({
            path: "/Content",
            query: { id: chapterObj.id, name: chapterObj.name }
          });
          //匹配当前内容的章节，并保存顺序
          //获取content_left,content_right确保滚动条在顶部
          this.$refs.content_left.scrollTop = 0;

          break;
        }
      }
    },
    //内容页tab
    click_tab(index) {
      //tab页切换停止当前正在播放的视频
      if (this.isVideo) {
        this.$refs.myVideoPlayer.player.pause();
      }
      for (let i = 0; i < this.content_tabs.length; i++) {
        if (i == index) {
          if (
            this.content_tabs[i].type == 2 ||
            this.content_tabs[i].type == 6
          ) {
            // 获取相应tab的图片组
            this.oldActiveChapterArrayData(
              this.content_tabs[i].cid,
              this.content_tabs[i].id
            );
            //储存当前点击的tab页id，在更新的时候重新匹配选中状态
            let activeTab = {
              id: this.content_tabs[i].id,
              name: this.content_tabs[i].title
            };
            window.sessionStorage.setItem(
              "activeTabId",
              JSON.stringify(activeTab)
            );
            break;
          } else {
            this.content_tabs[i].isActive = true;
            this.matchType(
              this.content_tabs[i].type,
              this.picturegroups,
              this.content_tabs[i].path
            );
            this.currentContent = this.content_tabs[i].content;
            window.sessionStorage.setItem("activeTabId", JSON.stringify(null));
          }
        } else {
          this.content_tabs[i].isActive = false;
        }
      }
    },
    // 初始化轮播图
    initSlide(picturegroups) {
      let slidesArr = [];
      for (let i = 0; i < picturegroups.length; i++) {
        let slideObj = { src: "", title: "" };
        slideObj.src = this.base_url().img_baseurl + picturegroups[i].path;
        slideObj.title = picturegroups[i].title;
        if (slideObj.src) {
          slidesArr.push(slideObj);
        }
      }
      this.slides = slidesArr;
    },
    // 判断内容页类型
    matchType(type, picturegroups, path) {
      //视频或者图片的路径
      let baseUrl = this.base_url().img_baseurl + path;
      switch (type) {
        case 0:
          //左图右文
          this.isSingleContentStructure = false;
          this.isSlide = false;
          this.isSingleImg = true;
          this.isVideo = false;
          this.leftImgUrl = baseUrl;
          break;
        case 1:
          //左视频右文
          this.isSingleContentStructure = false;
          this.isSlide = false;
          this.isVideo = true;
          this.isSingleImg = false;
          this.videoPath = baseUrl;
          break;
        case 2:
          //左图片组右文
          this.isSingleContentStructure = false;
          this.isSlide = true;
          this.isSingleImg = false;
          this.isVideo = false;
          if (picturegroups && picturegroups.length) {
            this.initSlide(picturegroups);
          }
          break;
        case 3:
          //左pdf右文
          this.isSingleContentStructure = false;
          this.isSlide = false;
          this.isSingleImg = false;
          this.isVideo = false;
          break;
        case 4:
          //单视频
          this.isSingleContentStructure = true;
          this.isSlide = false;
          this.isSingleImg = false;
          this.isVideo = true;
          this.videoPath = baseUrl;
          break;
        case 5:
          //单图片
          this.isSingleContentStructure = true;
          this.isSlide = false;
          this.isSingleImg = true;
          this.isVideo = false;
          this.leftImgUrl = baseUrl;
          break;
        case 6:
          //单图片组
          this.isSingleContentStructure = true;
          this.isSlide = true;
          this.isSingleImg = false;
          this.isVideo = false;
          if (picturegroups && picturegroups.length) {
            this.initSlide(picturegroups);
          }
          break;
        case 7:
          //表示单文
          this.isSingleContentStructure = true;
          this.isSlide = false;
          this.isSingleImg = false;
          this.isVideo = false;
          break;
        case 8:
          //单pdf
          this.isSingleContentStructure = true;
          this.isSlide = false;
          this.isSingleImg = false;
          this.isVideo = false;
          break;
      }
    },
    //获取内容页数据
    oldActiveChapterArrayData(chapterId, contentId) {
      if (!contentId) {
        contentId = null;
      }
      // pid  类型guid  章的id
      let isPhone = 0; //非手机
      if (document.body.clientWidth > 768) {
        isPhone = 1;
      }
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/Content", {
          cid: chapterId,
          isPhone: isPhone,
          contentId: contentId
        })
        .then(
          res => {
            let allcontent = JSON.parse(res.body.allcontent);
            this.picturegroups = JSON.parse(res.body.picturegroups);
            if (allcontent && allcontent.length) {
              //获取点击过的tabid
              let activeTab = JSON.parse(
                window.sessionStorage.getItem("activeTabId")
              );
              for (let i = 0; i < allcontent.length; i++) {
                // 匹配tab页的选中项
                if (activeTab && activeTab.id) {
                  if (allcontent[i].id == activeTab.id) {
                    allcontent[i].isActive = true;
                    //初始对应tab页内容
                    this.currentContent = allcontent[i].content;
                    //判断内容页类型
                    this.matchType(
                      allcontent[i].type,
                      this.picturegroups,
                      allcontent[i].path
                    );
                  } else {
                    allcontent[i].isActive = false;
                  }
                  //清空activeTabId
                  window.sessionStorage.setItem(
                    "activeTabId",
                    JSON.stringify(null)
                  );
                } else {
                  allcontent[0].isActive = true;
                  //初始第一个tab页内容
                  this.currentContent = allcontent[0].content;
                  //判断内容页类型
                  this.matchType(
                    allcontent[0].type,
                    this.picturegroups,
                    allcontent[0].path
                  );
                  break;
                }
              }
              this.content_tabs = allcontent;
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    }
  }
};
</script>

<style scoped>
@import "../css/contents.css";

</style>